export default function Disclaimer() {
  return (
  <div className="max-w-3xl mx-auto py-12 text-text-main">
    <h1 className="font-serif text-4xl md:text-5xl mb-4 tracking-wide">Disclaimer</h1>
    <p className="text-secondary text-sm mb-12 uppercase tracking-[0.2em] font-medium">Laatst bijgewerkt: 30 september 2026</p>
    
    <div className="space-y-8 text-secondary font-light leading-relaxed">
      <p>
        Deze website (<a href="https://www.residentieleo.be" className="hover:text-primary transition-colors">residentieleo.be</a>, hierna "de Website") wordt beheerd door Blueprint Development in het kader van de promotie van Project LEO, gelegen tussen de Leopoldstraat en de Floris Primsstraat te Grobbendonk. Door deze Website te raadplegen, aanvaard je onderstaande voorwaarden.
      </p>

      <h2 className="font-serif text-2xl text-text-main mt-10">Algemeen</h2>
      <p>
        De informatie op deze Website is louter informatief en publicitair van aard. Zij vormt geen bindend aanbod, offerte of contractueel document. Aan de inhoud van deze Website kunnen geen rechten worden ontleend.
      </p>

      <h2 className="font-serif text-2xl text-text-main mt-10">Beelden, plannen en visualisaties</h2>
      <p>
        Alle beelden, renders, 3D-visualisaties, plattegronden, sfeerbeelden en interieurvoorstellingen op deze Website zijn louter illustratief en niet bindend. Ze geven een artistieke impressie van het project en kunnen afwijken van de uiteindelijke realisatie op het vlak van onder meer materialen, kleuren, afwerking, inrichting, beplanting en omgeving. Meubilair, decoratie en aankleding op beelden maken geen deel uit van het aanbod, tenzij uitdrukkelijk anders vermeld.
      </p>

      <h2 className="font-serif text-2xl text-text-main mt-10">Oppervlaktes, prijzen en kenmerken</h2>
      <p>
        Vermelde oppervlaktes, indelingen, specificaties en eventuele prijsindicaties zijn indicatief en onder voorbehoud van latere wijzigingen om technische, stedenbouwkundige, architecturale of commerciële redenen. Enkel de bepalingen in de definitieve verkoopsdocumenten (compromis, notariële akte, lastenboek) zijn rechtsgeldig en bindend.
      </p>

      <h2 className="font-serif text-2xl text-text-main mt-10">Btw-tarief</h2>
      <p>
        Een aankoop onder het verlaagd btw-tarief van 6% is voor dit project onder bepaalde voorwaarden mogelijk (in plaats van het gewone tarief van 21%). Of je hiervoor in aanmerking komt, hangt af van je persoonlijke situatie en van de geldende wettelijke voorwaarden op het moment van aankoop. Deze vermelding is louter informatief en vormt geen garantie of fiscaal advies; neem contact op voor meer info over jouw situatie.
      </p>

      <h2 className="font-serif text-2xl text-text-main mt-10">Wijzigingen</h2>
      <p>
        Blueprint Development behoudt zich het recht voor om de inhoud van deze Website, het concept, het aanbod, de planning en de beschikbaarheid van de woningen op elk moment en zonder voorafgaande kennisgeving te wijzigen.
      </p>

      <h2 className="font-serif text-2xl text-text-main mt-10">Beschikbaarheid van de Website</h2>
      <p>
        Blueprint Development levert redelijke inspanningen om de Website up-to-date en toegankelijk te houden, maar garandeert niet dat de Website steeds foutloos, ononderbroken of vrij van technische storingen zal zijn.
      </p>

      <h2 className="font-serif text-2xl text-text-main mt-10">Aansprakelijkheid</h2>
      <p>
        Blueprint Development is niet aansprakelijk voor eventuele schade, van welke aard ook, die zou voortvloeien uit het gebruik van deze Website, uit de onmogelijkheid om ze te raadplegen, of uit het vertrouwen op de erop gepubliceerde informatie, behoudens in geval van bedrog, opzettelijke fout of zware fout in hoofde van Blueprint Development.
      </p>

      <h2 className="font-serif text-2xl text-text-main mt-10">Intellectuele eigendom</h2>
      <p>
        Alle teksten, beelden, logo's, grafische elementen en overige inhoud op deze Website zijn beschermd door intellectuele eigendomsrechten en zijn eigendom van Blueprint Development of van derden die toestemming hebben gegeven voor het gebruik ervan. Elke reproductie, verspreiding of ander gebruik zonder voorafgaande schriftelijke toestemming is verboden.
      </p>

      <h2 className="font-serif text-2xl text-text-main mt-10">Links naar derden</h2>
      <p>
        Deze Website kan links bevatten naar websites van derden (zoals sociale media of Google Maps). Blueprint Development heeft geen controle over de inhoud van deze externe websites en draagt hiervoor geen enkele verantwoordelijkheid.
      </p>

      <h2 className="font-serif text-2xl text-text-main mt-10">Toepasselijk recht en bevoegde rechtbank</h2>
      <p>
        Deze disclaimer wordt beheerst door het Belgische recht. Bij eventuele geschillen zijn uitsluitend de rechtbanken van het gerechtelijk arrondissement Antwerpen bevoegd.
      </p>

      <h2 className="font-serif text-2xl text-text-main mt-10">Contact</h2>
      <p>
        Voor vragen over deze disclaimer kun je contact opnemen via het contactformulier op deze Website of via Blueprint Development (<a href="https://blueprintdevelopment.be" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">blueprintdevelopment.be</a>).
      </p>
    </div>
  </div>
  );
}
